import { getSearchList } from "@/api/endpoints/searches";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const searchesQueryOptions = (orgUuid: Uuid) =>
  queryOptions({
    queryKey: [orgUuid, "searches"],
    queryFn: () => getSearchList({ light: true }),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

export function useSearches(orgUuid: Uuid) {
  return useQuery(searchesQueryOptions(orgUuid));
}
